// MUI theme from the shared Assets palette (UI design §2): amber accent, steel secondary, strict state colours.
import { palette } from '@fleetspoke/ui/tokens';
import { createTheme } from '@mui/material/styles';

export function buildTheme(mode: 'light' | 'dark') {
  const pick = (key: keyof typeof palette) => palette[key][mode];
  return createTheme({
    palette: {
      mode,
      primary: { main: pick('accent'), contrastText: '#FFFFFF' },
      secondary: { main: pick('steel') },
      success: { main: pick('ok') },
      warning: { main: pick('warn') },
      error: { main: pick('bad') },
      background: { default: pick('background'), paper: pick('surface') },
      text: { primary: pick('ink') },
    },
    shape: { borderRadius: 8 },
    typography: {
      fontFamily: 'Roboto, "Noto Sans SC", "Helvetica Neue", Arial, sans-serif',
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
    },
    components: {
      MuiTableCell: { styleOverrides: { root: { fontVariantNumeric: 'tabular-nums' } } },
      MuiButton: { defaultProps: { disableElevation: true } },
    },
  });
}
